import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {DEFAULT_GAME_FIELD, EMPTY_GAME_FIELD, EXPERIMENT_GAME_FIELDS} from '../configs/fields';
import {FIELD_PREVIEW_COMMON_LEGEND_IDS} from '../configs/fieldPreview';
import './FieldSelectMenu.css';
import {addClassNameIfTrue} from "../utils/other/addClassNameIfTrue";
import {isEnvConfEnabled} from "../utils/env/isEnvConfEnabled";
import {getFieldSelectGroups} from "../utils/fieldPreview/getFieldSelectGroups";
import {ENV_CONFIG_VARIABLES} from "../constants/env";
import PageButton from './elements/PageButton/PageButton';
import FieldPlayersCount from './elements/FieldPlayersCount/FieldPlayersCount';
import FloatingBackButton from './elements/FloatingBackButton/FloatingBackButton';
import FieldPreview from './FieldPreview/FieldPreview';
import FieldPreviewLegend from './FieldPreview/FieldPreviewLegend';
import {useFieldPreviewModel} from './FieldPreview/useFieldPreviewModel';
import {usePageAnalytics} from '../hooks/analytics/usePageAnalytics';

// Плитка карты: схема поля, название и вместимость
function FieldSelectTile({field, isLocalDev, onSelect}) {
  const model = useFieldPreviewModel(field.path);
  const isServiceField = field.id === EMPTY_GAME_FIELD.id
    || EXPERIMENT_GAME_FIELDS.some((item) => item.id === field.id);

  return (
    <PageButton
      className={`field-select-tile ${
        addClassNameIfTrue(
          field.id === DEFAULT_GAME_FIELD.id,
          isLocalDev ? 'field-select-tile_test-local' : 'field-select-tile_service'
        )
      } ${addClassNameIfTrue(isServiceField, 'field-select-tile_service')}`}
      onClick={() => onSelect(field)}
      pageId="FieldSelectMenu"
      buttonId={field.id}
    >
      <span className="field-select-tile_picture">
        <FieldPreview model={model}/>
      </span>
      <span className="field-select-tile_caption">
        <span className="field-select-button-name">{field.name}</span>
        <FieldPlayersCount playersCount={field.playersCount}/>
      </span>
    </PageButton>
  );
}

function FieldSelectMenu({onSelectField, onBack}) {
  const isLocalDev = isEnvConfEnabled(ENV_CONFIG_VARIABLES.REACT_APP_LOCAL_DEV_MODE);
  const auth = useSelector((state) => state.private.auth);
  const isAdminOrSuperAdmin = auth.isAdmin || auth.isSuperAdmin;

  // Тестовое/экспериментальные/пустое поля видны только админам/супер-админам
  // — обычные пользователи выбирают только из "боевых" GAME_FIELDS
  const groups = getFieldSelectGroups({isAdmin: isAdminOrSuperAdmin, isLocalDev});

  usePageAnalytics('FieldSelectMenu');

  useEffect(() => {
    if(isEnvConfEnabled(ENV_CONFIG_VARIABLES.REACT_APP_AUTO_LOAD_TEST_FIELD)) {
      onSelectField(DEFAULT_GAME_FIELD)
    }
  }, [onSelectField]);

  return (
    <>
      <FloatingBackButton onBack={onBack} pageId={'FieldSelectMenu'}/>

      <h1 className="menu-title field-select-menu_title">Игра против ботов</h1>
      <p className="field-select-menu_subtitle">Выберите карту:</p>

      <FieldPreviewLegend legendIds={FIELD_PREVIEW_COMMON_LEGEND_IDS} className="field-select-menu_legend"/>

      <div className="field-select-groups">
        {groups.map(({id, title, fields}) => (
          <section key={id} className="field-select-group" data-group={id}>
            <h2 className="field-select-group_title">{title}</h2>
            <div className="field-select-grid">
              {fields.map((field) => (
                <FieldSelectTile key={field.id} field={field} isLocalDev={isLocalDev} onSelect={onSelectField}/>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="main-menu-buttons">
        <PageButton
          className="main-menu-button" onClick={onBack} pageId="FieldSelectMenu" buttonId="back"
        >Назад</PageButton>
      </div>
    </>
  );
}

export default FieldSelectMenu;
